"use strict";

var _interopRequireWildcard = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/objectSpread2.js"));

var _tool = require("@/utils/tool");

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _vuex = require("vuex");

var echarts = _interopRequireWildcard(require("echarts"));

var _report = require("@/config/report");

var _report2 = require("@/api/report");

var _project = require("@/api/project");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'ProjectIndex',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      id: '',
      projectInfo: {},
      reportList: [],
      pageQuery: {
        total: 0,
        page: 1,
        limit: 20
      },
      reportNavList: _report.reportNavList,
      selectReportId: '',
      myChartRadar: ''
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['vipLevel', 'isVip'])),
  mounted: function mounted() {
    this.id = this.$route.params.id;
    this.getProjectInfo();
    this.getReportList(); // this.getRadar()
  },
  methods: {
    getUrl: _tool.getUrl,
    getProjectInfo: function getProjectInfo() {
      var _this = this;

      (0, _project.projectInfo)({
        game_id: this.id
      }).then(function (res) {
        _this.projectInfo = res.data.data;
      }); // this.projectInfo = {
      //   'game_id': 2,
      //   'game_name': '项目名称2',
      //   'root_cate': 1,
      //   'game_img': 'upload/111/5fd94b8f8a5b44d8e3e9c1b96065676b.png',
      //   'created_at': 1703688403
      // }
    },
    getReportList: function getReportList() {
      var _this2 = this;

      (0, _report2.informNormalList)({
        game_id: this.id,
        page: this.pageQuery.page - 1,
        pagesize: this.pageQuery.limit
      }).then(function (res) {
        _this2.reportList = res.data.data.list;
        console.log(_this2.reportList);
        _this2.pageQuery.total = res.data.data.total;

        if (_this2.reportList.length > 0) {
          for (var i = 0; i < _this2.reportList.length; i++) {
            var item = _this2.reportList[i];

            if (item.inform_status === 1 && item.create_status === 1) {
              _this2.selectReportId = item.inform_id;
            }
          }
        }
      });
    },
    gotoHome: function gotoHome() {
      this.$router.push({
        name: 'Home'
      });
    },
    gotoProjectInfo: function gotoProjectInfo() {
      this.$router.push({
        name: 'ProjectInfo',
        params: {
          id: this.id
        }
      });
    },
    selectReport: function selectReport(item) {
      if (!(item.inform_status === 2 || item.create_status === 0)) {
        this.selectReportId = item.inform_id;
      }
    },
    getRadar: function getRadar() {
      var json = {
        'perf': 50,
        'assets': 50,
        'size': 50
      };
      this.myChartRadar = echarts.init(document.getElementById('project-radar'), null, {
        renderer: 'svg'
      });
      var option = {
        radar: {
          // shape: 'circle',
          indicator: [{
            name: '项目资源',
            max: 100
          }, {
            name: '运行性能',
            max: 100
          }, {
            name: '包体大小',
            max: 100
          }],
          radius: '60%'
        },
        series: [{
          name: '项目数据',
          type: 'radar',
          data: [{
            value: [json.assets, json.perf, json.size],
            name: 'Actual Spending'
          }]
        }]
      };
      this.myChartRadar.setOption(option);
    },
    gotoReport: function gotoReport(name, isDisable) {
      if (isDisable) {
        // this.$message.warning('VIP等级不够，请提升VIP等级')
        return;
      }

      this.$router.push({
        name: name,
        params: {
          projectId: this.id,
          reportId: this.selectReportId
        }
      });
    },
    checkVipAllow: function checkVipAllow(itemVipLevel) {
      return this.isVip && this.vipLevel >= itemVipLevel;
    }
  }
};
exports.default = _default;